<template>
  <BriefStep :title="title" :tooltip="tooltip">
    <template v-slot:content>
      <div class="brief-form">
        <div class="form__input-wrapper form__input-wrapper--check">
          <input
            class=""
            id="haveHosting"
            type="radio"
            name="haveHosting"
            :value="true"
            v-model.trim="form.haveHosting"
            @input="delayTouch($v.form.haveHosting)"
          />
          <label for="haveHosting" class="form__label">tak, mam hosting</label>
        </div>
        <div class="form__input-wrapper form__input-wrapper--check">
          <input
            class=""
            id="dontHaveHosting"
            type="radio"
            name="haveHosting"
            :value="false"
            v-model.trim="form.haveHosting"
            @input="invokeTouch($v.form.haveHosting)"
            @click="hasDescription = true"
          />
          <label for="dontHaveHosting" class="form__label"
            >nie, nie mam hostingu
            <Tooltip :title="tooltipHosting" />
          </label>
        </div>
      </div>
    </template>
  </BriefStep>
</template>
<script>
import { required } from 'vuelidate/lib/validators';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import stepValidation from '../../mixins/stepValidation';

import BriefStep from '../global/BriefStep.vue';
import Tooltip from '../global/tooltip.vue';

export default {
  name: 'HaveHosting',
  components: { Tooltip, BriefStep },
  mixins: [stepValidation],
  data: () => ({
    title:
      'Każda strona potrzebuje ciepłego i bezpiecznego miejsca na serwerze. Zaznacz '
      + 'proszę, czy masz już wykupiony hosting.',
    tooltip:
      'Hosting czyli miejsce na serwerze, w którym Twoja strona będzie śmigać jak należy.',
    tooltipHosting:
      'W ramach hostingu oferujemy certyfikat SSL, a za pierwszy rok '
      + 'nie obciążamy Cię żadną, dodatkową opłatą.',
    form: {
      haveHosting: null,
    },
  }),
  validations: {
    form: {
      haveHosting: {
        required,
      },
    },
  },
};
</script>
